module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo7-e9d1c29e9ddf9bd0864c81a5c8068765.jpg";